<template>
  <el-dialog
    :title="id ? '编辑关键词' : '新增关键词'"
    :visible.sync="visible"
    width="620px"
  >
    <el-form
      ref="formRefs"
      :model="form"
      :rules="rules"
      label-width="120px"
      size="small"
    >
      <el-form-item label="站点ID" prop="site_id">
        <el-input-number
          v-model="form.site_id"
          :min="1"
          :precision="0"
          :controls="false"
          class="w-full"
          placeholder="请输入站点ID"
          @change="onSiteIdChange"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="站点选择">
        <el-select
          v-model="form.site_id"
          filterable
          clearable
          placeholder="请选择站点"
          class="w-full"
          @change="onSiteSelectChange"
        >
          <el-option
            v-for="item in siteOptions"
            :key="item.id"
            :label="`${item.id} - ${item.name}（${item.url}）`"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关键词" prop="keyword">
        <el-input
          v-if="id"
          v-model="form.keyword"
          placeholder="请输入关键词"
        ></el-input>
        <el-input
          v-else
          v-model="form.keyword"
          type="textarea"
          :rows="8"
          class="keyword-textarea"
          placeholder="请输入关键词，一行一个关键词&#10;例如：&#10;Gearbox&#10;industrial gearbox&#10;gearbox manufacturer"
        ></el-input>
      </el-form-item>
      <el-form-item label="关键词类型" prop="keyword_type">
        <el-select
          v-model="form.keyword_type"
          placeholder="请选择关键词类型"
          class="w-full"
        >
          <el-option
            v-for="item in keywordTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="目标域名" prop="target_domain">
        <el-input
          v-model="form.target_domain"
          placeholder="请输入目标域名"
        ></el-input>
      </el-form-item>
      <el-form-item label="目标URL" prop="target_url">
        <el-input v-model="form.target_url" placeholder="可选"></el-input>
      </el-form-item>
      <el-form-item label="国家/地区">
        <div class="flex">
          <el-input
            v-model="form.location_name"
            placeholder="例如 United States"
            class="mr-8px"
          ></el-input>
          <el-input
            v-model="form.location_code"
            placeholder="地区代码"
            class="w-140px"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="语言" prop="language_code">
        <el-input v-model="form.language_code" placeholder="en"></el-input>
      </el-form-item>
      <el-form-item label="设备" prop="device">
        <el-radio-group v-model="form.device">
          <el-radio label="desktop">桌面端</el-radio>
          <el-radio label="mobile">移动端</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="搜索量">
        <el-input-number
          v-model="form.search_volume"
          :min="0"
          :controls="false"
          class="w-full"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="CPC">
        <el-input-number
          v-model="form.cpc"
          :min="0"
          :precision="4"
          :controls="false"
          class="w-full"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="竞争度">
        <div class="flex">
          <el-input-number
            v-model="form.competition"
            :min="0"
            :precision="4"
            :controls="false"
            class="mr-8px flex-1"
          ></el-input-number>
          <el-input
            v-model="form.competition_level"
            placeholder="LOW/MEDIUM/HIGH"
            class="w-160px"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="参与排名查询" prop="include_in_rank_check">
        <el-switch
          v-model="form.include_in_rank_check"
          :active-value="1"
          :inactive-value="0"
          active-text="参与"
          inactive-text="不参与"
        ></el-switch>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-switch
          v-model="form.status"
          :active-value="1"
          :inactive-value="0"
          active-text="正常"
          inactive-text="停用"
        ></el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button type="primary" size="small" :loading="loading" @click="onSave"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  apiSeoKeywordAdd,
  apiSeoKeywordDetail,
  apiSeoKeywordEdit,
  apiSeoSiteOptions,
} from "@/api/seo";

const defaultForm = () => ({
  site_id: undefined,
  keyword: "",
  keyword_type: "long_tail",
  target_domain: "",
  target_url: "",
  location_code: "",
  location_name: "United States",
  language_code: "en",
  device: "desktop",
  search_volume: undefined,
  cpc: undefined,
  competition: undefined,
  competition_level: "",
  include_in_rank_check: 1,
  status: 1,
});

export default {
  data() {
    return {
      id: 0,
      visible: false,
      loading: false,
      siteOptions: [],
      form: defaultForm(),
      keywordTypeOptions: [
        { label: "主词", value: "core" },
        { label: "长尾词", value: "long_tail" },
        { label: "品牌词", value: "brand" },
        { label: "竞品词", value: "competitor" },
      ],
      rules: {
        site_id: [
          { required: true, message: "请选择或输入站点ID", trigger: "blur" },
        ],
        keyword: [
          {
            required: true,
            message: "请输入关键词，多个关键词请一行一个",
            trigger: "blur",
          },
        ],
        keyword_type: [
          { required: true, message: "请选择关键词类型", trigger: "change" },
        ],
        target_domain: [
          { required: true, message: "请输入目标域名", trigger: "blur" },
        ],
        language_code: [
          { required: true, message: "请输入语言", trigger: "blur" },
        ],
        device: [{ required: true, message: "请选择设备", trigger: "change" }],
        include_in_rank_check: [
          {
            required: true,
            message: "请选择是否参与排名查询",
            trigger: "change",
          },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },
  methods: {
    openDialog(id) {
      this.id = id || 0;
      this.visible = true;
      this.form = {
        ...defaultForm(),
      };
      this.getSiteOptions();
      this.$nextTick(() => {
        this.$refs.formRefs && this.$refs.formRefs.clearValidate();
      });
      if (this.id) {
        this.getDetail();
      }
    },
    getSiteOptions() {
      apiSeoSiteOptions().then((resp) => {
        this.siteOptions = resp || [];
        if (
          this.form.site_id &&
          !this.form.target_domain &&
          !this.form.target_url
        ) {
          this.fillSiteDefaults(this.form.site_id);
        }
      });
    },
    getDetail() {
      apiSeoKeywordDetail({ id: this.id }).then((resp) => {
        this.form = {
          ...defaultForm(),
          ...resp,
          site_id: Number(resp.site_id),
          location_code: resp.location_code || "",
        };
      });
    },
    onSiteIdChange(siteId) {
      this.fillSiteDefaults(siteId);
    },
    onSiteSelectChange(siteId) {
      this.fillSiteDefaults(siteId);
    },
    fillSiteDefaults(siteId) {
      const site = this.siteOptions.find((item) => item.id === Number(siteId));
      if (!site) return;
      this.form.target_url = site.url || "";
      this.form.target_domain = this.extractDomain(site.url);
    },
    extractDomain(url) {
      try {
        return new URL(url).hostname;
      } catch (e) {
        return String(url || "")
          .replace(/^https?:\/\//, "")
          .replace(/\/.*$/, "");
      }
    },
    onSave() {
      this.$refs.formRefs.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const request = this.id ? apiSeoKeywordEdit : apiSeoKeywordAdd;
        request({
          ...this.form,
          id: this.id,
        })
          .then(() => {
            this.$message({ type: "success", message: "保存成功" });
            this.visible = false;
            this.$emit("refresh");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.keyword-textarea {
  ::v-deep .el-textarea__inner {
    min-height: 168px;
    line-height: 22px;
    overflow-y: auto;
    resize: vertical;
  }
}
</style>
